import React from 'react';
import {
  BookOpen,
  Calendar,
  User,
  Users,
  DollarSign,
  Eye,
  Edit,
  Trash2,
  FileText
} from 'lucide-react';

const FormationCard = ({ formation, onView, onEdit, onDelete }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  };

  const formatPrice = (price) => {
    if (!price || price === 0) return 'Gratuit';
    return `${parseFloat(price).toLocaleString('fr-FR')} FCFA`;
  };

  return (
    <div className="bg-white rounded-xl shadow-sm hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-100">
      {/* Image de couverture */}
      <div className="relative h-48 bg-gradient-to-br from-[#FF6B00] to-[#437011] overflow-hidden">
        {formation.couverture ? (
          <img
            src={`http://192.168.1.65:8000${formation.couverture}`}
            alt={formation.titre}
            className="w-full h-full object-cover"
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <BookOpen size={64} className="text-white opacity-50" />
          </div>
        )}
        
        {/* Badge Type */}
        <div className="absolute top-3 right-3">
          {formation.isPaid ? (
            <span className="px-3 py-1 bg-green-600 text-white text-xs font-bold rounded-full shadow-lg flex items-center gap-1">
              <DollarSign size={12} />
              Payante
            </span>
          ) : (
            <span className="px-3 py-1 bg-blue-600 text-white text-xs font-bold rounded-full shadow-lg">
              Gratuite
            </span>
          )}
        </div>
      </div>

      {/* Contenu */}
      <div className="p-5 space-y-4">
        {/* Titre */}
        <div>
          <h3 className="text-lg font-bold text-gray-900 line-clamp-2 mb-2">
            {formation.titre}
          </h3>
          {formation.description && (
            <p className="text-sm text-gray-600 line-clamp-2">
              {formation.description}
            </p>
          )}
        </div>

        {/* Auteur */}
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-full bg-gradient-to-br from-blue-500 to-purple-500 flex items-center justify-center text-white font-bold text-sm">
            {formation.auteur?.first_name?.[0] || formation.auteur?.username?.[0] || 'A'}
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-gray-900 truncate">
              {formation.auteur?.first_name && formation.auteur?.last_name
                ? `${formation.auteur.first_name} ${formation.auteur.last_name}`
                : formation.auteur?.username || 'Auteur'}
            </p>
            <p className="text-xs text-gray-500 truncate">{formation.auteur?.email}</p>
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 gap-3">
          <div className="bg-blue-50 rounded-lg p-3">
            <div className="flex items-center gap-2 mb-1">
              <Users size={16} className="text-blue-600" />
              <span className="text-xs text-blue-600 font-medium">Participants</span>
            </div>
            <p className="text-lg font-bold text-blue-700">{formation.participants_count || 0}</p>
          </div>

          {formation.isPaid && (
            <div className="bg-green-50 rounded-lg p-3">
              <div className="flex items-center gap-2 mb-1">
                <DollarSign size={16} className="text-green-600" />
                <span className="text-xs text-green-600 font-medium">Prix</span>
              </div>
              <p className="text-sm font-bold text-green-700 truncate">
                {formatPrice(formation.prix)}
              </p>
            </div>
          )}
        </div>

        {/* Date */}
        <div className="flex items-center gap-2 text-xs text-gray-500 pt-2 border-t border-gray-100">
          <Calendar size={14} />
          <span>Créée le {formatDate(formation.created_at)}</span>
        </div>
      </div>

      {/* Actions */}
      <div className="p-4 bg-gray-50 border-t border-gray-100 flex gap-2">
        <button
          onClick={() => onView(formation)}
          className="flex-1 px-3 py-2 bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-lg hover:shadow-lg transition-all duration-200 flex items-center justify-center gap-2 text-sm font-medium"
        >
          <Eye size={16} />
          Voir
        </button>
        <button
          onClick={() => onEdit(formation)}
          className="flex-1 px-3 py-2 bg-gradient-to-r from-[#FF6B00] to-[#e55d00] text-white rounded-lg hover:shadow-lg transition-all duration-200 flex items-center justify-center gap-2 text-sm font-medium"
        >
          <Edit size={16} />
          Modifier
        </button>
        <button
          onClick={() => onDelete(formation)}
          className="px-3 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors flex items-center justify-center"
          title="Supprimer"
        >
          <Trash2 size={16} />
        </button>
      </div>
    </div>
  );
};

export default FormationCard;
